import { render, staticRenderFns } from "./staffSet.vue?vue&type=template&id=378ecda0&scoped=true&"
import script from "./staffSet.vue?vue&type=script&lang=js&"
export * from "./staffSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378ecda0",
  null
  
)

export default component.exports